import React from "react";
import { Link } from "react-router-dom";

const SingleArtistProduct = ({ artist,product }) => {

  return (
    <div>
      { artist.id===product.artist.id &&
          <div className="productSingleCard">
        <div className="cardImg">
          <div className="content-overlay"></div>
          <img src={product.main_image} alt="" />
          <div className="content-details fadeIn-bottom text-white d-flex justify-content-center">
            <a
              className="hoverIcon d-flex justify-content-center align-items-center"
              href="/"
            >
              <div className="hoverIconImg">
                <Link to={`/singleproduct/${product.id}`}>
                  {" "}
                  <img src={require("../../Asset/icon/addSmall.png")} alt="" />
                </Link>
              </div>
            </a>
            <a
              className="hoverIcon d-flex justify-content-center align-items-center"
              href="/"
            >
              <div className="hoverIconImg">
                <img src={require("../../Asset/icon/heart.png")} alt="" />
              </div>
            </a>
            <a
              className="hoverIcon d-flex justify-content-center align-items-center"
              href="/"
            >
              <div className="hoverIconImg">
                <img src={require("../../Asset/icon/cart.png")} alt="" />
              </div>
            </a>
          </div>
        </div>
        <div className="cardContent ">
          <div className="d-flex justify-content-between align-items-end p-4">
            <div>
              <h6 className="semibold ">
                <Link
                  to={`/singleproduct/${product.id}`}
                  style={{ color: "black" }}
                >
                  {product.name}
                </Link>
              </h6>
              <p className="fs16 m-0">{product.artist.artist_name}</p>
            </div>
            <div>
              <p className="fs20 cl-pm m-0">
                {" "}
                $ <span>{product.price}</span>
              </p>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
};

export default SingleArtistProduct;
